import { useCountdown } from "../../hooks/useCountdown";

export const InlineCountdown = ({ target, testid, short = false }) => {
  const { dd, hh, mm, ss } = useCountdown(target);
  return (
    <span data-testid={testid} className="font-bold tabular-nums tracking-wide text-[#F5D77A]">
      {short ? `${dd}:${hh}:${mm}` : `${dd} days ${hh}:${mm}:${ss}`}
    </span>
  );
};

export const BoxCountdown = ({ target, testid, className = "" }) => {
  const { dd, hh, mm, ss } = useCountdown(target);
  const cells = [[dd, "Days"], [hh, "Hours"], [mm, "Minutes"], [ss, "Seconds"]];
  return (
    <div data-testid={testid} className={`grid grid-cols-4 gap-2 sm:gap-4 ${className}`}>
      {cells.map(([v, l]) => (
        <div key={l} className="flex flex-col items-center rounded-xl border border-[#D4AF37]/50 bg-[#0A0A0A] px-1 py-3 shadow-[inset_0_0_24px_-10px_rgba(212,175,55,.35)] sm:rounded-2xl sm:py-5">
          <span className="f-cinzel gold-text text-3xl font-bold tabular-nums sm:text-5xl">{v}</span>
          <span className="mt-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#A39E93] sm:text-xs">{l}</span>
        </div>
      ))}
    </div>
  );
};
